export default "__VITE_ASSET__DLhej0bY__"